import { Fragment } from 'react';
import { Page } from '../theme/elements/Page';
import { Box, Stack, Typography } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { CountriesTable } from 'sections/CountriesManagement/CountriesTable';
import { getCountries } from 'state/reducers/global.reducer';

export const CountriesManagementApp = () => {
	const t = useAppSelector(selectTranslations);
	const countriesEditPermission = hasPermission([permissionEnums.EDIT_COUNTRIES]);
	const countries = useAppSelector(getCountries);

	return (
		<Fragment>
			<Page>
				<>
					<Stack spacing={6}>
						<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
							<Typography variant="pageTitle">{t('page.countries_management.title')}</Typography>
						</Box>
						{countriesEditPermission && <CountriesTable countries={countries} />}
					</Stack>
				</>
			</Page>
		</Fragment>
	);
};
